/* This component is a child of PricingPlans. This component imports the Tabs component which displays the tab labels, and the active tab content for the
 * monthly pricing selection. This component will need to import basic-features, mid-features and premium-features.js and those components will
 * live within the cooresponding divs below in order to be displayed wihtin each tab.
 * Tabs is a child of the monthly and annual pricing components
 * the "label" tags in the divs is IMPORTANT. Do not remove the tabs and tab components won't know which tab is active or what label to display
 */

import React from 'react';
import Tabs from './tabs';
import { StaticQuery, graphql } from 'gatsby';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import './styles.css';
import PricingPageStyle from './pricing-page.module.scss';

const MonthlyPricingMobile = () => (
  <StaticQuery
    query={graphql`
      query MonthlyPricingMobile {
        contentfulPricingPlansAssemblyPage {
          basicMonthlyPricing {
            monthlySetupFee
            monthlySupportFee
            activeFeatures {
              json
            }
            inactiveFeatures {
              json
            }
            addOnFeatures {
              json
            }
            activeSupport {
              json
            }
            inactiveSupport {
              json
            }
          }
          midLevelMonthlyPricing {
            monthlySetupFee
            monthlySupportFee
            activeFeatures {
              json
            }
            inactiveFeatures {
              json
            }
            addOnFeatures {
              json
            }
            activeSupport {
              json
            }
          }
          premiumMonthlyPricing {
            monthlySetupFee
            monthlySupportFee
            activeFeatures {
              json
            }
            inactiveFeatures {
              json
            }
            addOnFeatures {
              json
            }
            activeSupport {
              json
            }
            inactiveSupport {
              json
            }
          }
        }
      }
    `}
    render={(data) => (
      <div className={PricingPageStyle.annualPricing}>
        <Tabs>
          <div label='Starter'>
            {/* Basic Pricing */}
            <h3 className={PricingPageStyle.basicPlanTitleMobile}>Starter</h3>
            <h4 className={PricingPageStyle.pricingPlanMthlyPrice}>
              {
                data.contentfulPricingPlansAssemblyPage.basicMonthlyPricing
                  .monthlySupportFee
              }
            </h4>
            <p>
              {
                data.contentfulPricingPlansAssemblyPage.basicMonthlyPricing
                  .monthlySetupFee
              }
            </p>
            {/* Starter Checkout */}
            <a
              href='https://app.firststringdigital.com/starter-monthly'
              className={PricingPageStyle.choosePlanBtn1}
            >
              Let's Get Started
            </a>

            {/* Basic Active Features */}
            <div className={PricingPageStyle.activeFeaturesDiv}>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.basicMonthlyPricing
                  .activeFeatures.json
              )}
            </div>

            {/* Basic Inactive Features -- None exist at this tme --  */}
            <div
              className={`${PricingPageStyle.basicInactiveFeaturesDiv} ${PricingPageStyle.inactiveFeaturesDiv}`}
            >
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.basicMonthlyPricing
                  .inactiveFeatures.json
              )}
            </div>

            <hr />

            {/* Basic Active Ongoing Support */}
            <div className={PricingPageStyle.activeSupportDiv}>
              <h4>Ongoing Support</h4>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.basicMonthlyPricing
                  .activeSupport.json
              )}
            </div>

            {/* Basic Inactive Ongoing Support */}
            <div className={PricingPageStyle.inactiveSupportDiv}>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.basicMonthlyPricing
                  .inactiveSupport.json
              )}
            </div>

            <hr />

            {/* Basic Add-on Features */}
            <div className={PricingPageStyle.addonFeaturesDiv}>
              <h4>Add-on Features</h4>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.basicMonthlyPricing
                  .addOnFeatures.json
              )}
            </div>

            {/* Starter Checkout */}
            <a
              href='https://app.firststringdigital.com/starter-monthly'
              className={PricingPageStyle.choosePlanBtn1}
            >
              Let's Get Started
            </a>
          </div>
          <div label='Entree'>
            {/* Midlevel Pricing */}
            <h3 className={PricingPageStyle.midLevelPlanTitleMobile}>Entree</h3>
            <h4 className={PricingPageStyle.pricingPlanMthlyPrice}>
              {
                data.contentfulPricingPlansAssemblyPage.midLevelMonthlyPricing
                  .monthlySupportFee
              }
            </h4>
            <p>
              {
                data.contentfulPricingPlansAssemblyPage.midLevelMonthlyPricing
                  .monthlySetupFee
              }
            </p>
            {/* Entree Checkout */}
            <a
              href='https://app.firststringdigital.com/entree-monthly'
              className={PricingPageStyle.choosePlanBtn2}
            >
              Let's Get Started
            </a>

            {/* Midlevel Active Features */}
            <div className={PricingPageStyle.activeFeaturesDiv}>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.midLevelMonthlyPricing
                  .activeFeatures.json
              )}
            </div>

            {/* MidLevel Inactive Features -- None at this time -- */}
            <div
              className={`${PricingPageStyle.midLevelInactiveFeaturesDiv} ${PricingPageStyle.inactiveFeaturesDiv}`}
            >
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.midLevelMonthlyPricing
                  .inactiveFeatures.json
              )}
            </div>

            <hr />

            {/* Midlevel Active Ongoing Support */}
            <div className={PricingPageStyle.activeSupportDiv}>
              <h4>Ongoing Support</h4>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.midLevelMonthlyPricing
                  .activeSupport.json
              )}
            </div>

            {/* Midlevel Inactive Ongoing Support */}
            {/* <div className={PricingPageStyle.inactiveSupportDiv}>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.midLevelMonthlyPricing
                  .inactiveSupport.json
              )}
            </div> */}

            <hr />

            {/* Midlevel Add-on Features */}
            <div
              className={`${PricingPageStyle.midLevelAddonFeaturesDiv} ${PricingPageStyle.addonFeaturesDiv}`}
            >
              <h4>Add-on Features</h4>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.midLevelMonthlyPricing
                  .addOnFeatures.json
              )}
            </div>

            {/* Entree Checkout */}
            <a
              href='https://app.firststringdigital.com/entree-monthly'
              className={PricingPageStyle.choosePlanBtn2}
            >
              Let's Get Started
            </a>
          </div>
          <div label='Dessert'>
            {/* Premium Level Pricing */}
            <h3 className={PricingPageStyle.premiumPlanTitleMobile}>Dessert</h3>
            <h4 className={PricingPageStyle.pricingPlanMthlyPrice}>
              {
                data.contentfulPricingPlansAssemblyPage.premiumMonthlyPricing
                  .monthlySupportFee
              }
            </h4>
            <p>
              {
                data.contentfulPricingPlansAssemblyPage.premiumMonthlyPricing
                  .monthlySetupFee
              }
            </p>
            {/* Dessert Checkout */}
            <a
              href='https://app.firststringdigital.com/dessert-monthly'
              className={PricingPageStyle.choosePlanBtn3}
            >
              Let's Get Started
            </a>

            {/* Premium Active Features */}
            <div className={PricingPageStyle.activeFeaturesDiv}>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.premiumMonthlyPricing
                  .activeFeatures.json
              )}
            </div>

            {/* Premium Inactive Features */}
            <div
              className={`${PricingPageStyle.premiumInactiveFeaturesDiv} ${PricingPageStyle.inactiveFeaturesDiv}`}
            >
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.premiumMonthlyPricing
                  .inactiveFeatures.json
              )}
            </div>

            <hr />

            {/* Premium Active Ongoing Support */}
            <div className={PricingPageStyle.activeSupportDiv}>
              <h4>Ongoing Support</h4>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.premiumMonthlyPricing
                  .activeSupport.json
              )}
            </div>

            <hr />

            {/* Premium Add-on Features */}
            <div
              className={`${PricingPageStyle.premiumAddonFeaturesDiv} ${PricingPageStyle.addonFeaturesDiv}`}
            >
              <h4>Add-on Features</h4>
              {documentToReactComponents(
                data.contentfulPricingPlansAssemblyPage.premiumMonthlyPricing
                  .addOnFeatures.json
              )}
            </div>

            {/* Dessert Checkout */}
            <a
              href='https://app.firststringdigital.com/dessert-monthly'
              className={PricingPageStyle.choosePlanBtn3}
            >
              Let's Get Started
            </a>
          </div>
        </Tabs>
      </div>
    )}
  />
);

export default MonthlyPricingMobile;
